package com.tregz.polyglot.ai

/**
 * Validates machine translations before they are shown or persisted to the shared cache.
 * Keeps only entries whose key exists in the source table, whose value is non-blank and
 * whose placeholder tokens (%s, %1$d, {name}, ${name}, {{name}}) match the source.
 */
object PolyglotValidator {
    private const val MIN_COVERAGE_PERCENT = 80

    private val placeholder = Regex("""%(?:\d+\$)?[sdf@]|\$\{[^}]*\}|\{\{[^}]*\}\}|\{[^{}]*\}""")

    private fun tokens(text: String): List<String> = placeholder.findAll(text).map { it.value }.sorted().toList()

    fun sanitize(source: Map<String, String>, candidate: Map<String, String>): Map<String, String> {
        val result = LinkedHashMap<String, String>()
        for ((key, value) in candidate) {
            val original = source[key] ?: continue
            if (original.isBlank() || value.isBlank()) continue
            if (tokens(original) != tokens(value)) continue
            result[key] = value
        }
        return result
    }

    /** True when enough of the translatable source entries survived validation. */
    fun isAcceptable(source: Map<String, String>, sanitized: Map<String, String>): Boolean {
        val expected = source.count { it.value.isNotBlank() }
        if (expected == 0) return true
        return sanitized.isNotEmpty() && sanitized.size * 100 >= expected * MIN_COVERAGE_PERCENT
    }
}
